/* eslint-disable */
import { Duck, DuckSelector, createSelector } from '@atc/modular-redux';
import _get from 'lodash/get';
import { getBreadcrumbData, getBreadcrumbValueKey, getLabelValuePairs } from './helpers';
const DEFAULT_EMPTY_OBJECT = {};
export default duck => ({
  getLocalState: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState)),
  getBreadcrumbsConfig: new Duck.Selector(selectors => createSelector(selectors.getLocalState, localState => _get(localState, 'breadcrumbs', DEFAULT_EMPTY_OBJECT))),
  getFiltersOptions: new Duck.Selector(selectors => createSelector(selectors.getLocalState, localState => _get(localState, 'options', DEFAULT_EMPTY_OBJECT))),
  getValuesState: new Duck.Selector(selectors => createSelector(selectors.getLocalState, localState => _get(localState, 'values', DEFAULT_EMPTY_OBJECT))),
  getFiltersErrors: new Duck.Selector(selectors => createSelector(selectors.getLocalState, localState => _get(localState, 'errors', DEFAULT_EMPTY_OBJECT))),
  getFiltersVisible: new Duck.Selector(selectors => createSelector(selectors.getLocalState, localState => _get(localState, 'visible', false))),
  getFiltersValues: new Duck.Selector(selectors => createSelector(selectors.getValuesState, filtersValues => Object.keys(filtersValues).reduce((acc, key) => {
    const value = _get(filtersValues, [key, 'value'], false);
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {}))),
  getRequestValues: new Duck.Selector(selectors => createSelector(selectors.getValuesState, filtersValues => Object.keys(filtersValues).reduce((acc, key) => {
    const segments = key.split('|');
    const valueKey = segments[0];
    const value = _get(filtersValues, [key, 'value']);

    // omit undefined/null/empty values
    if (!value || value === '') {
      return acc;
    }

    // Assign the current filter value to the accumulator if there isn't one present already
    if (!acc[valueKey]) {
      acc[valueKey] = null;
    }

    // If the value is an array or is a value for a previously designed key
    // then we add that value to an array
    if (Array.isArray(acc[valueKey]) || acc[valueKey] !== null) {
      acc[valueKey] = [].concat(acc[valueKey], value);
    } else {
      acc[valueKey] = value;
    }
    return acc;
  }, {}))),
  getRequestQueryValues: new Duck.Selector(selectors => createSelector(selectors.getRequestValues, requestValues => Object.keys(requestValues).reduce((acc, key) => {
    const value = requestValues[key];
    return {
      ...acc,
      [key]: Array.isArray(value) ? value.join(',') : value
    };
  }, {}))),
  getBreadcrumbsValueKeys: new Duck.Selector(selectors => createSelector(selectors.getBreadcrumbsConfig, selectors.getFiltersValues, (breadcrumbConfig, values) => Object.keys(breadcrumbConfig).reduce((acc, breadcrumbKey) => {
    const {
      filterKey
    } = _get(breadcrumbConfig, [breadcrumbKey], {});
    if (Array.isArray(filterKey)) {
      filterKey.forEach(key => acc.push(getBreadcrumbValueKey(key, values)));
    } else {
      acc.push(getBreadcrumbValueKey(filterKey, values));
    }
    return acc;
  }, []))),
  hasBreadcrumbs: new DuckSelector(selectors => createSelector(selectors.getBreadcrumbsValueKeys, selectors.getFiltersValues, (breadcrumbsValueKeys, values) => {
    const hasValidBreadcrumbs = breadcrumbsValueKeys.reduce((acc, valueKey) => {
      const value = _get(values, valueKey, false);
      if (value) {
        // if multiple values have been selected then abort
        if (Array.isArray(value) && value.length > 1) {
          acc.push(false);
        }

        // return true if we have a value
        acc.push(true);
      }
      return acc;
    }, []);
    return Array.isArray(hasValidBreadcrumbs) && hasValidBreadcrumbs.length > 0 && !hasValidBreadcrumbs.includes(false);
  })),
  /**
   * Builds a reference map of filter option labels keyed by their values
   * @return {Object}
   */
  getLabelsByValues: new DuckSelector(selectors => createSelector(selectors.getFiltersOptions, filtersOptions => Object.keys(filtersOptions).reduce((acc, key) => {
    const options = _get(filtersOptions, [key, 'options'], false);

    // Process standard filter options
    if (options) {
      acc[key] = getLabelValuePairs(options);
      return acc;
    }

    // Process remaining filter options sets aand only handle multi-filter options.
    // e.g. modelCodeList|BMW
    Object.keys(filtersOptions[key]).forEach(multiKey => {
      if (multiKey.includes('|')) {
        const multiOptions = _get(filtersOptions, [key, multiKey, 'options'], []);
        acc[multiKey] = getLabelValuePairs(multiOptions);
      }
    });
    return acc;
  }, {}))),
  /**
   * returns all keys for filters with values that have been set.
   * multi-filter key values (ex: 'foo|bar' and 'foo|baz' are collapsed to just 'foo')
   */
  getSelectedFilterKeys: new DuckSelector(selectors => createSelector(selectors.getFiltersValues, values => Object.keys(values).reduce((acc, key) => {
    const valueKey = key.split('|')[0];
    if (!acc.includes(valueKey)) {
      acc.push(valueKey);
    }
    return acc;
  }, []))),
  getBreadcrumbMetadata: new Duck.Selector(selectors => createSelector(selectors.hasBreadcrumbs, selectors.getBreadcrumbsConfig, selectors.getFiltersValues, selectors.getLabelsByValues, selectors.getSelectedFilterKeys, (hasBreadcrumbs, breadcrumbConfig, values, labelsByValues, selectedFilterKeys) => {
    // we want to bail out of this and return an empty array if any filter value has multiple selections
    // realistically this should have been checked at the component usage level
    // but we are just protecting ourselves in case it wasn't
    if (!hasBreadcrumbs) {
      return DEFAULT_EMPTY_OBJECT;
    }
    return Object.keys(breadcrumbConfig).reduce((acc, breadcrumbKey) => {
      const {
        filterKey
      } = _get(breadcrumbConfig, breadcrumbKey, {});
      let data;
      if (Array.isArray(filterKey)) {
        // Set data attribute to be an array to store aggrated metadata
        data = [];

        // update the data with an array of populated data for each filterKey
        filterKey.forEach(key => {
          data.push(getBreadcrumbData(key, values, labelsByValues));
        });
      } else {
        data = getBreadcrumbData(filterKey, values, labelsByValues);
      }
      return {
        ...acc,
        [breadcrumbKey]: data
      };
    }, {});
  }))
});